import React from "react"
import Layout from '../components/layout'

const ResourcePage = () => {
  return (
      <Layout>
        <h1>Resources</h1>
            <p>
            This is a list of links to various resources that will help you in getting started and also taking 
            your knowledge further. The essential tools list contains everything you need to work with during
            the course. 
            </p>
            <h2>Essentials</h2>
            <div id = 'textGrid_01'> 
              <p>
                Designing Programs
                </p>
                <p>
                <a href = "https://designingprograms.bitbucket.io/">www.designingprograms.bitbucket.io</a>               
                </p>
                <p>
                Designing Programs source code 
                </p>
                <p>
                <a href = "https://bitbucket.org/designingprograms/designingprograms.bitbucket.io/downloads/">www.dp/code</a>               
                </p> 
                <p>
                  The Computational Graphic Design Manual
                </p>
                <p>
                <a href = "https://dpmanual.bitbucket.io">https://dpmanual.bitbucket.io</a>       
                </p>         
                <p>
                  The official website for Processing
                </p>
                <p>
                <a href = "https://www.processing.org/">www.processing.org</a>       
                </p>     
                <p>
                  Explore sketches with OpenProcessing
                </p>
                <p>
                  <a href = "https://www.openprocessing.org/">www.openprocessing.org</a> 
                </p>

                <p>
                  A collection of Processing programs
                </p>
                <p>
                  <a href = "https://github.com/FreeArtBureau/DesigningPrograms/archive/master.zip">www.github.com/FreeArtBureau</a> 
                </p>


            <h2>Blogs/Places/People</h2>
            <p></p>
              <p>
                New Media Projects & Resources
              </p>
              <p>
                <a href = "http://www.creativeapplications.net/">www.creativeapplications.net</a> 
              </p>
              <p>
                Processing Projects
              </p>
              <p>
                <a href = "https://www.creativeapplications.net/category/processing/">www.creativeapplications.net</a> 
              </p>
              <p>
                Moving Image Collection (installations/video/docs)
              </p>
              <p>
                <a href = "https://vimeo.com/channels/moving">www.vimeo.com/channels/moving</a> 
              </p>
             
              <p>
                Eyeo Festival Lectures
              </p>
              <p>
                <a href = "https://vimeo.com/eyeofestival">www.vimeo.com/eyeofestival</a> 
              </p>
              <p>
                ZKM | Center for Art & Media
              </p>
              <p>
                <a href = "https://zkm.de/en/collection-archives/video-audio">www.zkm.de</a> 
              </p>
              <p>
                Eyeondesign | Great Design blog
              </p>
              <p>
                <a href = "https://eyeondesign.aiga.org/category/design-series/design-history-101/#5">www.eyeondesign.aiga.org</a> 
              </p>
              <p>
                Computer Art History
              </p>
              <p>
                <a href = "https://monoskop.org/Computer_art">www.monoskop.org/Computer_art</a> 
              </p>
              <p>
                Nice Collection of Articles (French)
              </p>
              <p>
                <a href = "http://strabic.fr/">www.strabic.fr</a> 
              </p>
              <p>
                A list of some contemporary artists
              </p>
              <p>
                <a href = "http://formandcode.com/links">www.formandcode.com/links</a> 
              </p>
              
              
            <h2>Books</h2>
            <p></p>
              <p>
                Form & Code
              </p>
              <p>
               <a href = "http://formandcode.com/">www.formandcode.com</a> 
              </p>                     
              
              <p>
                Generative Design book + source code
              </p>
              <p>
               <a href = "http://www.generative-gestaltung.de/2/">www.generative-gestaltung.de/2</a> 
              </p>
              <p>
                Online book in French
              </p>
              <p>
                <a href = "https://fr.flossmanuals.net/processing/introduction/">www.flossmanuals.net</a> 
              </p>

              <p>
                Culture Numérique. Dominique Cardon
              </p>
              <p>
                <a href = "https://www.franceculture.fr/oeuvre/culture-numerique">SciencesPo Les Presses, 2019.</a> 
              </p>
              <p>
                La Pensée Informatique. Gérard Berry
              </p>
              <p>
                <a href = "https://www.cnrseditions.fr/catalogue/sciences-de-l-ingenieur/la-pensee-informatique/">CNRS Éditions, 2019.</a> 
              </p>
              <p>
                Le Temps des Algorithmes. S. Abiteboul, G. Dowek
              </p>
              <p>
                <a href = "https://www.les-philosophes.fr/technique/temps-des-algorithmes.html">Essai Le Pommier, 2017.</a> 
              </p>

              
              
              
            <h2>Web</h2>
            <p></p>
              <p>
                Processing for the web with P5js
              </p>
              <p>
                <a href = "https://p5js.org/">www.p5js.org</a> 
              </p>
              <p>
                P5js examples
              </p>
              <p>
                <a href = "https://esad2020.bitbucket.io/">www.esad2020.bitbucket.io</a> 
              </p>
              
              <p>
                Learn about web tech (html/css/js)
              </p>
              <p>
                <a href = "https://developer.mozilla.org/en-US/">www.developer.mozilla.org</a> 
              </p>
              <p>
                Making web pages - A detailed intro
              </p>
              <p>
                <a href = "https://learn.shayhowe.com/html-css/building-your-first-web-page/">www.learn.shayhowe.com</a> 
              </p>
              <p>
                Nice set of tutorials about web (French)
              </p>
              <p>
                <a href = "https://www.isitcode.net/">www.isitcode.net</a> 
              </p>
             
              <p>
                Visual Studio Code Editor
              </p>
              <p>
                <a href = "https://code.visualstudio.com/">www.code.visualstudio.com</a> 
              </p>
              
            
            <h2>Divers</h2>
            <p></p> 
              <p>
                Some personal references ;––)
              </p>
              <p>
                <a href = "https://www.are.na/mark-webster-1526199907">www.are.na</a> 
              </p>
              
              <p>
                Free & Open Source Philosophy
              </p>
              <p>
                <a href = "https://www.gnu.org/philosophy/open-source-misses-the-point.html">www.gnu.org</a> 
              </p>
            
              <p>
                Glossary of definitions / Glossaire >
              </p>
              <p>
                <a href = "http://www.revue-backoffice.com/en/glossary">English</a> /
                <a href = "http://www.revue-backoffice.com/glossaire">French</a> 
              </p>

              <h2></h2>
              <p></p>
            </div> 
      </Layout>
  )
}


export default ResourcePage
